import axios, { AxiosInstance } from 'axios'
import { AuthLoginRequest, AuthState, Api, ApiUser, ApiPatient, ApiOffice, ApiDevice, ApiTest } from './types'
import TestDataProcess from '@/helpers/testDataProcess'
import { auth } from './store/auth'

// const baseURL = process.env.NODE_ENV === 'production' ? 'https://urogo.medensy.com' : 'http://localhost'
const baseURL = 'https://urogo.medensy.com'

const http: AxiosInstance = axios.create({
  baseURL: `${baseURL}/api/`
})

const getConfig = ({ tokenType, accessToken }: AuthState) => {
  return {
    headers: {
      'Authorization': `${tokenType} ${accessToken}`
    }
  }
}

const user: ApiUser = {
  async login ({ email, password }: AuthLoginRequest) {
    return http
      .post('/user/login', { email, password }, { withCredentials: true })
      .then(resp => resp.data)
  },
  async get (auth) {
    return http
      .get('/user', getConfig(auth))
      .then(resp => resp.data)
  },
  async refresh () {
    return http.get('/user/refresh', {
      withCredentials: true
    }).then(resp => resp.data)
  }
}

const patient: ApiPatient = {
  async getPatients (auth) {
    return http
      .get('/patients', getConfig(auth))
      .then(resp => resp.data)
  },
  async post (auth, data) {
    return http
      .post('/patient', data, getConfig(auth))
      .then(resp => resp.data)
  },
  async patch (auth, data, id) {
    return http
      .patch(`/patient/${id}`, data, getConfig(auth))
      .then(resp => resp.data)
  },
  async delete (auth, id) {
    return http
      .delete(`/patient/${id}`, getConfig(auth))
      .then(resp => resp.data)
  },
  async getTestsFromPatientId (auth, id) {
    return http
      .get('/patient/tests', { ...getConfig(auth), params: { id } })
      .then(resp => resp.data)
  }
}

const office: ApiOffice = {
  async getDevices (auth) {
    return http
      .get('/office/devices', getConfig(auth))
      .then(resp => resp.data)
  },
  async postDevice (auth, data) {
    return http
      .post('/office/device', data, getConfig(auth))
      .then(resp => resp.data)
  },
  async patchDevice (auth, data, id) {
    return http
      .patch(`/office/device/${id}`, data, getConfig(auth))
      .then(resp => resp.data)
  },
  async deleteDevice (auth, id) {
    return http
      .delete(`/office/device/${id}`, getConfig(auth))
      .then(resp => resp.data)
  }
}

const device: ApiDevice = {
  async loanDevice (auth, patient_id, deviceId) {
    return http
      .post(`/device/${deviceId}/loan`, { patient_id }, getConfig(auth))
      .then(resp => resp.data)
  },
  async returnDevice (auth, deviceId) {
    return http
      .post(`/device/${deviceId}/return`, {}, getConfig(auth))
      .then(resp => resp.data)
  }
}

const test: ApiTest = {
  async getTestJson (auth, id) {
    return http
      .get(`/test/${id}/file`, getConfig(auth))
      .then(resp => {
        return new TestDataProcess().fromJson(resp.data)
      })
  },
  async markTime (auth, id, {
    start,
    end
  }) {
    return http
      .post(`/test/mark/${id}`, {
        'mark_start': start,
        'mark_end': end
      }, getConfig(auth))
      .then(resp => resp.data)
  }
}

const api: Api = {
  user,
  patient,
  office,
  device,
  test
}

export default api
